<script lang="ts">

import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import IconComponent from "@/components/atoms/Icon.vue";
import { TranslationKey, SearchQASelectors, AccessibilityHandler } from "webshop-modules";
import { ITab } from "@/domain/search/entitites/Tab.interface";

@Component({
    components: {
        IconComponent,
    }
})
export default class TabsComponent extends Vue {

    @Prop()
    public initialTab!: string;
    @Prop()
    public tabs: ITab[] = [];
    @Prop()
    public modifier!: string;

    @Emit()
    public tabSwitched(): boolean {
        return true;
    }

    @Emit() activeTabChange(): string {
        return this.activeTab;
    }

    @Emit() closeAndSave(): boolean {
        return true;
    }

    public readonly Translation: typeof TranslationKey = TranslationKey;
    public readonly SearchQASelectors: typeof SearchQASelectors = SearchQASelectors;


    public activeTab = '';
    public selected = false;
    public showBackButton = false;

    get tabPanelSlotName() {
        return `a-tabPanel-${this.activeTab}`;
    }

    get tabPanelBtnSlotName() {
        return `a-tabPanelBtn-${this.activeTab}`;
    }

    public tabHeadSlotName(tabName: string) {
        return `a-tabHead-${tabName}`;
    }

    public switchTab(tabName: string) {
        if (tabName === this.activeTab) {
            return;
        }

        if (this.modifier === '-searchFilters' && this.activeTab !== this.modifier) {
            // this.$emit('tabSwitched');
            this.tabSwitched();
        }

        if (this.activeTab === tabName && !window.matchMedia('(min-width: 640px)').matches) {
            this.selected = false;
            this.activeTab = this.modifier;
        } else {
            this.activeTab = tabName;
            // this.$emit('activeTab', this.activeTab);
            this.activeTabChange();

            if (!window.matchMedia('(min-width: 640px)').matches && this.modifier === '-searchFilters') {
                this.selected = true;
            }
        }
    }

    public confirm() {
        if (this.activeTab === this.modifier) {
            this.closeAndSave();
        } else {
            this.activeTab = this.modifier;
            this.selected = false;
        }
    }

    public handleKeyPress(event: KeyboardEvent, tabName: string) {
        AccessibilityHandler.handleActionWithCallback(event, () => {
            this.switchTab(tabName);
        });
    }

    /**
     * Created lifecycle hook
     */
    private created() {
        if (window.matchMedia('(min-width: 640px)').matches || this.modifier !== '-searchFilters') {
            this.activeTab = this.initialTab;
        } else {
            this.activeTab = this.modifier;
            this.showBackButton = true;
        }

    }

}
</script>

<template>
    <div v-bind:class="modifier" class="o-tabs">
        <ul class="m-tabList">
            <li v-for="tab in tabs"
                v-bind:class="['a-tabHead', {
                        'a-tabHead--active': activeTab === tab.name,
                        '-selected': selected
                    }]"
                :key="tab.name"
                v-on:click="switchTab(tab.name)"
                @keydown="handleKeyPress($event, tab.name)"
                tabindex="0">
                <span v-if="tab.badgeValue && activeTab !== tab.name" class="a-badgeCount">{{ tab.badgeValue }}</span>
                <slot :name="tabHeadSlotName(tab.name)">
                    <span v-translate="{key: tab.translationObject?.key}"></span>
                </slot>
            </li>
            <li class="a-tabHead__filters">
                <slot :name="modifier"></slot>
            </li>
        </ul>
        <div class="m-tabMain">
            <div class="a-tabPanel" :data-qa="SearchQASelectors.TAB_PANEL">
                <slot :name="tabPanelSlotName"></slot>
            </div>
            <div class="a-tabPanelFooter">
                <slot :name="tabPanelBtnSlotName" v-if="showBackButton">
                    <button type="button" class="a-btnCta -action" aria-label="Confirm" @click="confirm">
                        <span v-translate="{ key: Translation.Confirm}"></span>
                    </button>
                </slot>
            </div>
        </div>
    </div>
</template>
